import { render, staticRenderFns } from "./email-display.vue?vue&type=template&id=6548c495&scoped=true&"
import script from "./email-display.vue?vue&type=script&lang=ts&"
export * from "./email-display.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6548c495",
  null
  
)

export default component.exports